import React from 'react';
import Grid from '@mui/material/Grid';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';

export const statusTitle = (status, type) => {
    switch (status) {
        case 'DRAFT':
            return (
                <Grid container alignItems={'center'} spacing={1}>
                    <Grid item>
                        <ModeEditIcon
                            sx={{ color: '#999ba8' }}
                            fontSize={type === 'dialog' ? 'medium' : 'small'}
                        />
                    </Grid>
                    {type === 'dialog' && (
                        <Grid item>
                            <Typography variant={'h6'} color={'textSecondary'}>
                                {status}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            );
        case 'RECEIVED':
            return (
                <Grid container alignItems={'center'} spacing={1}>
                    <Grid item>
                        <ThumbUpAltIcon
                            sx={{ color: '#4168AE' }}
                            fontSize={type === 'dialog' ? 'medium' : 'small'}
                        />
                    </Grid>
                    {type === 'dialog' && (
                        <Grid item>
                            <Typography variant={'h6'} color={'primary'}>
                                {status}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            );
        case 'SUCCESS':
            return (
                <Grid container alignItems={'center'} spacing={1}>
                    <Grid item>
                        <CheckCircleIcon
                            sx={{ color: '#4caf50' }}
                            fontSize={type === 'dialog' ? 'medium' : 'small'}
                        />
                    </Grid>
                    {type === 'dialog' && (
                        <Grid item>
                            <Typography variant={'h6'} color={'#4caf50'}>
                                {status}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            );
        case 'ERROR':
            return (
                <Grid container alignItems={'center'} spacing={1}>
                    <Grid item>
                        <ErrorIcon
                            sx={{ color: '#ef5350' }}
                            fontSize={type === 'dialog' ? 'medium' : 'small'}
                        />
                    </Grid>
                    {type === 'dialog' && (
                        <Grid item>
                            <Typography variant={'h6'} color={'#ef5350'}>
                                {status}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            );
        default:
            return null;
    }
};
